export default "__VITE_ASSET__DV0qrA37__"